module.exports = __webpack_public_path__ + "static/media/pin.e55e6ceb.svg";